import axios from 'axios';
import { clearAdminToken, getAdminToken } from '../utils/adminAuth';

const clinicsApi = axios.create({
  baseURL: '/api/v1/clinics',
  withCredentials: true
});

clinicsApi.interceptors.request.use(
  (config) => {
    const token = getAdminToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

clinicsApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      clearAdminToken();
      if (typeof window !== 'undefined') {
        window.location.href = '/web/admin-login';
      }
    }
    return Promise.reject(error);
  }
);

export const listClinics = async (params = {}) => {
  const response = await clinicsApi.get('', { params });
  return response.data;
};

export const createClinic = async (payload) => {
  const response = await clinicsApi.post('', payload);
  return response.data;
};

export const patchClinic = async (id, payload) => {
  const response = await clinicsApi.patch(`/${id}`, payload);
  return response.data;
};

export const deleteClinic = async (id) => {
  const response = await clinicsApi.delete(`/${id}`);
  return response.data;
};
